
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-8 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/0b4f7418-3232-4564-af45-5866f395eb9c.png" 
              alt="REM OOD Logo" 
              className="h-12 w-auto object-contain"
            />
            <h1 className={`ml-4 text-2xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              REM OOD
            </h1>
          </div>
          <div className="flex items-center space-x-8">
            <a
              onClick={() => scrollToSection('products')}
              className={`text-base font-medium cursor-pointer transition-colors hover:text-teal-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Products
            </a>
            <a
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium cursor-pointer transition-colors hover:text-teal-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </a>
            <a
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium cursor-pointer transition-colors hover:text-teal-500 ${
                scrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
